import { render, staticRenderFns } from "./_CollectChart.vue?vue&type=template&id=6368b783&"
import script from "./_CollectChart.vue?vue&type=script&lang=js&"
export * from "./_CollectChart.vue?vue&type=script&lang=js&"
import style0 from "./_CollectChart.vue?vue&type=style&index=0&id=6368b783&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports